var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendNa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 16.75C25.25 17.3516 24.7773 17.7812 24.2188 17.7812H8.40625C7.80469 17.7812 7.375 17.3516 7.375 16.75C7.375 16.1914 7.80469 15.7188 8.40625 15.7188H24.2188C24.7773 15.7188 25.25 16.1914 25.25 16.75Z",
    fill: "#D0D0DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendNa);
export default __webpack_public_path__ + "static/media/trend-na.0211f948f884024696d51ed9a48b553c.svg";
export { ForwardRef as ReactComponent };